import * as e from "react";
import a from "../lib/IconBase.es.js";
import f from "../defs/CaretDoubleLeft.es.js";
const o = e.forwardRef((t, r) => /* @__PURE__ */ e.createElement(a, { ref: r, ...t, weights: f }));
o.displayName = "CaretDoubleLeftIcon";
const s = o;
export {
  s as CaretDoubleLeft,
  o as CaretDoubleLeftIcon
};
